import VueRouter, { RouteConfig } from 'vue-router'

const Index = () => import('../activity/summer-vacation-2022-homework/Index.vue')

export const indexRoute: RouteConfig = {
  path: '/summer-vacation-2022-activity',
  name: 'summer_vacation_2022_activity',
  component: Index,
  meta: {
    title: '暑假作业活动',
  },
}

export default [indexRoute]

export function navigateToSummerVacation2022Activity(router: VueRouter) {
  router.push({ name: indexRoute.name })
}
